import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  rating: number;
  views: number;
  chapters: number;
  status: string;
  category: string;
  updatedAt?: string;
  tags?: string[];
}

function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return views.toString();
}

export default function ComicCard({ id, title, author, cover, rating, views, chapters, status, updatedAt, tags }: ComicCardProps) {
  return (
    <article className="group" data-product-shop>
      <Link to={`/comic/${id}`} className="block cursor-pointer">
        <div className="relative overflow-hidden rounded-xl aspect-[3/4] mb-3">
          <img
            src={cover}
            alt={title}
            title={`${title} - 073漫画网在线免费阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
            <span className="text-background-50 text-xs font-medium bg-primary-500/90 px-2 py-1 rounded-md whitespace-nowrap">立即阅读</span>
          </div>
          <div className="absolute top-2 left-2">
            <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
              status === '已完结'
                ? 'bg-accent-500 text-background-50'
                : 'bg-primary-500 text-background-50'
            }`}>
              {status}
            </span>
          </div>
          <div className="absolute top-2 right-2 bg-background-950/70 backdrop-blur-sm rounded-full px-2 py-0.5 flex items-center gap-1">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
            </div>
            <span className="text-background-50 text-xs font-medium">{rating}</span>
          </div>
        </div>
        <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
          {title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="whitespace-nowrap">{author}</span>
          <span className="text-foreground-300">·</span>
          <span className="whitespace-nowrap">共{chapters}话</span>
        </div>
        {updatedAt && (
          <p className="text-xs text-foreground-400 mt-1">
            更新至{chapters}话 · {updatedAt}
          </p>
        )}
        <p className="text-xs text-foreground-500 mt-1 flex items-center gap-1">
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-eye-line text-xs"></i>
          </div>
          {formatViews(views)}次阅读
        </p>
        {tags && tags.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-2">
            {tags.slice(0, 3).map((tag) => (
              <span key={tag} className="text-xs bg-background-100 text-foreground-600 px-2 py-0.5 rounded-full whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
        )}
      </Link>
    </article>
  );
}